"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _uuid = _interopRequireDefault(require("uuid"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

var StepTemplatesApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(StepTemplatesApi, _BasicDataHubApi);

  function StepTemplatesApi() {
    (0, _classCallCheck2.default)(this, StepTemplatesApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StepTemplatesApi).apply(this, arguments));
  }

  (0, _createClass2.default)(StepTemplatesApi, [{
    key: "getStepTemplates",
    value: function () {
      var _getStepTemplates = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref) {
        var _ref$query, query, projection, forceSandbox, result, last, responce;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref$query = _ref.query, query = _ref$query === void 0 ? {} : _ref$query, projection = _ref.projection, forceSandbox = _ref.forceSandbox;
                result = [];

              case 2:
                query.last = last;
                _context.next = 5;
                return this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/step-templates"),
                  queryParams: {
                    projection: projection,
                    query: query,
                    sandbox: forceSandbox
                  }
                });

              case 5:
                responce = _context.sent;
                result = result.concat(responce.items);
                last = responce.last;

              case 8:
                if (last) {
                  _context.next = 2;
                  break;
                }

              case 9:
                return _context.abrupt("return", result);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getStepTemplates(_x) {
        return _getStepTemplates.apply(this, arguments);
      }

      return getStepTemplates;
    }()
  }, {
    key: "getStepTemplatesByToken",
    value: function () {
      var _getStepTemplatesByToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref2) {
        var _ref2$query, query, projection, limit, token, _ref2$forceSandbox, forceSandbox, binding;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, projection = _ref2.projection, limit = _ref2.limit, token = _ref2.token, _ref2$forceSandbox = _ref2.forceSandbox, forceSandbox = _ref2$forceSandbox === void 0 ? false : _ref2$forceSandbox;
                _context2.next = 3;
                return this.getBinding();

              case 3:
                binding = _context2.sent;
                return _context2.abrupt("return", binding.query.listTemplates({
                  entity: _constants.STEP_TEMPLATE,
                  params: {
                    queryParams: query,
                    limit: limit,
                    last: token
                  },
                  sourceId: query.sourceId,
                  forceSandbox: forceSandbox
                }, projection || ['records', 'last']));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getStepTemplatesByToken(_x2) {
        return _getStepTemplatesByToken.apply(this, arguments);
      }

      return getStepTemplatesByToken;
    }()
  }, {
    key: "getStepTemplateById",
    value: function () {
      var _getStepTemplateById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(id) {
        var query,
            projection,
            _ref3,
            _ref4,
            step,
            _args3 = arguments;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                query = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                projection = _args3.length > 2 ? _args3[2] : undefined;
                query.id = id;
                _context3.next = 5;
                return this.getStepTemplates({
                  query: query,
                  projection: projection
                });

              case 5:
                _ref3 = _context3.sent;
                _ref4 = (0, _slicedToArray2.default)(_ref3, 1);
                step = _ref4[0];
                return _context3.abrupt("return", step);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getStepTemplateById(_x3) {
        return _getStepTemplateById.apply(this, arguments);
      }

      return getStepTemplateById;
    }()
  }, {
    key: "getRawStepTemplateById",
    value: function getRawStepTemplateById(id) {
      return this._callApi({
        path: "/v2/".concat(this.accountIdFactory, "/step-template/").concat(id, "/latest")
      });
    }
    /**
     * Copy step to flow
     * @param {(string|{step: Object, flowId: string})} options Step ID or object with `id`, `version`, `isExternal` and `isSandbox` keys.
     * @param {string} destFlowId Destination Flow ID
     * @returns {Promise}
     */

  }, {
    key: "copyToFlow",
    value: function () {
      var _copyToFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(options, destFlowId) {
        var stepId, flowId, binding;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                stepId = (0, _get2.default)(options, 'step.id', options);
                flowId = (0, _get2.default)(options, 'flowId', destFlowId);

                if (!(0, _get2.default)(options, 'step.isExternal')) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", this._callApi({
                  method: "POST",
                  path: "/v2/".concat(this.accountIdFactory, "/flow/").concat(flowId, "/step"),
                  payload: options.step
                }));

              case 4:
                _context4.next = 6;
                return this.getBinding();

              case 6:
                binding = _context4.sent;
                return _context4.abrupt("return", binding.mutation.downloadTo({
                  entity: _constants.STEP_TEMPLATE,
                  data: {
                    id: stepId,
                    body: {
                      flowId: flowId
                    }
                  }
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function copyToFlow(_x4, _x5) {
        return _copyToFlow.apply(this, arguments);
      }

      return copyToFlow;
    }()
  }, {
    key: "getMostDownloaded",
    value: function () {
      var _getMostDownloaded = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref5) {
        var _ref5$pagination, pagination, sort, projection, binding;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref5$pagination = _ref5.pagination, pagination = _ref5$pagination === void 0 ? {
                  limit: 1000
                } : _ref5$pagination, sort = _ref5.sort, projection = _ref5.projection;
                _context5.next = 3;
                return this.getBinding();

              case 3:
                binding = _context5.sent;
                return _context5.abrupt("return", binding.query.getDownloads({
                  type: _constants.STEP,
                  pagination: pagination,
                  sort: sort
                }, projection));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMostDownloaded(_x6) {
        return _getMostDownloaded.apply(this, arguments);
      }

      return getMostDownloaded;
    }()
  }], [{
    key: "getNewStepTemplate",
    value: function getNewStepTemplate(stepId) {
      return {
        id: stepId || _uuid.default.v4(),
        // this won't change in a future versions of a step
        version: '0.0.1',
        cacheVersion: _uuid.default.v4(),
        // this will change every time you save a step template
        label: '',
        icon: '',
        iconType: 'default',
        iconUrl: '',
        shape: 'circle',
        description: '',
        dateCreated: Date.now(),
        dateModified: Date.now(),
        publishedBy: '',
        template: "/* Your custom logic goes here. */\n// This exits the step down the exit leg labeled `next`\nreturn this.exitStep('next' /*, outputData */ );\n//  This second argument is optional output data, which\n//  will be stored in the step's merge field upon exit.",
        categories: [],
        form: {
          style: '',
          template: '',
          code: ''
        },
        data: {
          exits: []
        },
        modules: [],
        reporting: {
          step: {
            label: 'Step',
            type: 'step',
            enabled: true,
            tags: []
          }
        },
        outputExample: null,
        formBuilder: {
          stepExits: [{
            component: 'exitStatic',
            data: {
              id: 'next',
              label: 'next'
            }
          }],
          stepInputs: [],
          hasDataOut: false,
          hasProcessError: false,
          outputExample: null
        },
        rawMode: false,
        hooks: null
      };
    }
  }]);
  return StepTemplatesApi;
}(_basic_data_hub_api.default);

var _default = StepTemplatesApi;
exports.default = _default;